import React from "react";
import { Row, Col, List, Table, Button } from "antd";
import { render } from "react-dom";

const App = () => {
    const dataSource = [
        {
            key: '1',
            date: '04/23',
            name: '神奇柑仔店9～12套書',
            author: ' 廣嶋玲子 ',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: <Button type="text" style={{ backgroundColor: 'rgb(234,247,238)' }}>已採購</Button>
        },
        {
            key: '2',
            date: '05/02',
            name: '生活是一場熱情的遊戲',
            author: ' 吳家德 ',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
        {
            key: '3',
            date: '05/13',
            name: '真的假的！奇怪知識又增加了：自說自話的總裁顛覆認知的科學奇想【博客來獨家簽名版】',
            author: ' 自說自話的總裁',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
        {
            key: '4',
            date: '05/21',
            name: '甜點品味學──蛋糕、塔派、泡芙、可頌、馬卡龍……深入剖析五感體驗，學習多元風味的拆解與重組',
            author: ' 瑪莉詠．堤露, 馬修．達梅  ',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
        {
            key: '5',
            date: '05/22',
            name: '世界冠軍的完美居家咖啡指南──從豆子的購買、挑選、研磨、保存到沖煮，頂尖職人運用圖表與步驟，解說在家也能做出好咖啡的關鍵技巧，建立屬於你的自家風味',
            author: ' 詹姆斯．霍夫曼 ',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
        {
            key: '5',
            date: '05/30',
            name: '神樂坂的緣分星期四',
            author: ' 平岡陽明 ',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
        {
            key: '5',
            date: '06/17',
            name: '即使，這道淚光今晚就會從世界上消失',
            author: '一条岬',
            ISBN: parseInt(Math.random() * 10000000000000),
            amount: parseInt(Math.random(10) * 10),
            state: '已採購'
        },
    ];

    const columns = [
        {
            title: '推薦日期',
            dataIndex: 'date',
            key: 'date',
            width: '6em'
        },
        {
            title: '推薦書名',
            dataIndex: 'name',
            key: 'name',
            width: '20rem',
            // ellipsis: true,
            render: (text) => <a style={{ textDecoration: 'none', color: 'black' }}>{text}</a>
        },
        {
            title: '作者',
            dataIndex: 'author',
            key: 'author',
            width: '15rem',
            // ellipsis: true,
            render: (text) => <a style={{ textDecoration: 'none', color: 'black' }}>{text}</a>
        },
        {
            title: 'ISBN',
            dataIndex: 'ISBN',
            key: 'ISBN',
            ellipsis: true
        },
        {
            title: '館藏',
            dataIndex: 'amount',
            key: 'amount',
            width: '4em'
        },
        {
            title: '狀態',
            dataIndex: 'state',
            key: 'state',
            width: '5em',
            render: (_, __, index) => (<>
                {index % 3 === 0&&<Button type="text" style={{ borderRadius:5,backgroundColor: 'rgb(234,247,238)', color: 'rgb(31,149,76)' }}>已採購</Button>}
                {index % 3 !== 0&&<Button type="text" style={{ borderRadius:5,backgroundColor: 'rgb(253,253,231)', color: 'rgb(228,156,74)' }}>處理中</Button>}
            </>)
        },
    ];
    return (<>
        <Row style={{ padding: '0px 20px' }}>
            <Col span={24}>
                <Row justify={'center'}>
                    <Col>
                        <div style={{ fontSize: '2em', fontWeight: '400', padding: '20px' }}>讀者推薦清單</div>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Table
                    dataSource={dataSource}
                     columns={columns} 
                     size="small"
                    scroll={{ x: "max-content"}}
                />
            </Col>
        </Row>
    </>)
}

export default App